import { render, staticRenderFns } from "./TrainChangeDetail.vue?vue&type=template&id=5bed6aed&scoped=true&"
import script from "./TrainChangeDetail.vue?vue&type=script&lang=js&"
export * from "./TrainChangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainChangeDetail.vue?vue&type=style&index=0&id=5bed6aed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed6aed",
  null
  
)

export default component.exports